import React, { useContext } from 'react'
import { Link } from 'gatsby'
import { IoCartOutline } from 'react-icons/io5'
import { HiOutlineUser } from 'react-icons/hi'
import { UserDataContext } from '@context/userContext'
import { BuyDataContext } from '@context/buyContext'

function Avatar() {
  const userData = useContext(UserDataContext)
  const buyData = useContext(BuyDataContext)
  const {
    modal,
    setModal,
    isAuthenticated,
    setModalAuthType,
    setDrawerCart,
    drawerCart
  } = userData
  const { modalOpen } = modal
  const { products } = buyData
  const { user } = userData
  const { names } = user

  const handleOptionSession = type => {
    if (type === 'login') {
      setModalAuthType('login')
    }
    // if (type === 'register') {
    //   setModalAuthType('register')
    // }
    setModal(!modalOpen)
  }

  console.log(names)

  return (
    <div className="flex-row items-center justify-center text-center">
      {!isAuthenticated || names === 'Invitado' ? (
        <div className="flex flex-row gap-4 lg:gap-8">
          <Link to="/carrito" className="flex flex-col items-center justify-center">
            <div className=" relative mb-1 flex h-8 w-8 items-center justify-center self-center rounded-full bg-[#8FB946] md:h-8 md:w-8">
              <IoCartOutline className="text-2xl text-white" title="Carrito" />
              {/*
              <span className="absolute -top-1 -right-1 h-4 w-4 rounded-full border-black bg-white text-xs text-primary">
                {products.length}
              </span>
              */}
            </div>
            <h4 className="hidden text-xs font-semibold text-green-700 xs:flex">
              Carrito
            </h4>
          </Link>
          <button
            className="flex flex-col items-center justify-center"
            onClick={() => handleOptionSession('login')}
          >
            <div className=" mb-1 flex h-9 w-9 items-center justify-center self-center rounded-full bg-gray-100 drop-shadow-lg md:h-8 md:w-8">
              <HiOutlineUser className=" text-2xl text-gray-500" title="Avatar" />
            </div>
            <h4 className="flex text-xs font-semibold">Ingresar</h4>
          </button>
        </div>
      ) : (
        <div className="flex flex-row gap-4 lg:gap-8">
          <Link to="/carrito" className="flex flex-col items-center justify-center">
            <div className=" relative mb-1 flex h-9 w-9 items-center justify-center self-center rounded-full bg-[#8FB946] md:h-10 md:w-10">
              <IoCartOutline className="text-2xl text-white" title="Carrito" />
              {/*
              <span className="absolute -top-1 -right-1 h-4 w-4 rounded-full border-black bg-white text-xs text-primary">
                {products.length}
              </span>
              */}
            </div>
            <h4 className="hidden text-xs font-semibold text-green-700 xs:flex">
              Carrito
            </h4>
          </Link>
          <Link to="/perfil" className="flex flex-col items-center justify-center">
            <div className=" mb-1 flex h-9 w-9 items-center justify-center self-center rounded-full bg-[#8FB946] md:h-10 md:w-10">
              <HiOutlineUser className="text-2xl text-white" title="Perfil" />
            </div>
            <h4 className="hidden text-xs font-semibold text-green-700 xs:flex">
              Perfil
            </h4>
          </Link>
        </div>
      )}
    </div>
  )
}

export default Avatar
